import { render, staticRenderFns } from "./Seances.vue?vue&type=template&id=1ac452db&"
import script from "./Seances.vue?vue&type=script&lang=js&"
export * from "./Seances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports